<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-icon color="white" large>mdi-water-outline</v-icon>
      </div>

      <span class="main-toolbar-title">{{ $t('Controle de Consumo') }}</span>

      <v-spacer></v-spacer>
    </div>

    <div class="mt-4">
      <v-tabs color="secondary" v-model="tab">
        <v-tab class="rounded-lg rounded-b-0">{{ $t('Indicadores') }}</v-tab>
        <v-tab
          class="rounded-lg rounded-b-0"
          v-if="institution.userType < 4 || institution.userType == 8"
          >Tipos de Consumo</v-tab
        >
        <v-tab
          class="rounded-lg rounded-b-0"
          v-if="institution.userType < 4 || institution.userType == 8"
          >{{ $t('Leituras') }}</v-tab
        >
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-tabs grow color="secondary" v-model="reportTab">
          <v-tab
            v-for="(page, id) in reportPages"
            :key="id"
            @click="report.setPage(page.name)"
            class="rounded-lg rounded-b-0"
          >
            {{ page.displayName }}
          </v-tab>
        </v-tabs>

        <div id="reportContainer"></div>
      </v-tab-item>

      <v-tab-item>
        <div class="d-flex justify-end">
          <v-btn
            class="secondary-button mr-4"
            depressed
            to="consumption/manage"
          >
            {{ $t('Cadastrar tipo') }}
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="typeFilter.pageSize"
          class="main-table"
          hide-default-footer
          hide-default-header
          mobile-breakpoint="0"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.name`]="{ item }">
            <span>
              {{ item.name }}
            </span>
          </template>

          <template #[`item.createdAt`]="{ item }">
            <span> {{ formatDate(item.createdAt) }} </span>
          </template>
          <template #[`item.unityName`]="{ item }">
            <span> {{ item.unityName }} </span>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#0F3565"
                  dark
                  small
                  depressed
                  :to="`/consumption/manage?id=${item.id}`"
                  v-on="on"
                >
                  <v-icon size="22">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Editar') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#921616"
                  depressed
                  small
                  dark
                  @click="openDelete(item)"
                  v-on="on"
                >
                  <v-icon size="22">mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Excluir') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="btn"
                  depressed
                  color="#C0C0C0"
                  small
                >
                  qtd: {{ typeFilter.pageSize }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(size, i) in sizes"
                  :key="i"
                  @click="typeFilter.pageSize = size"
                >
                  <v-list-item-title>{{ size }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="registros" v-if="items.length">
              <span>
                1 - {{ items.length }} de {{ typeFilter.totalItems }}
              </span>
              <br />
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="typeFilter.page"
              :length="typeFilter.totalPages"
              :total-visible="5"
            ></v-pagination>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="d-flex justify-end">
          <v-btn class="secondary-button mr-4" depressed @click="addReading()">
            {{ $t('Cadastrar leitura') }}
          </v-btn>
        </div>

        <v-row class="ma-0" justify="end">
          <v-col cols="2">
            <span class="text ml-1">{{ $t('Tipo de consumo') }}</span>
            <v-autocomplete
              v-model="reportFilter.name"
              placeholder="Selecione"
              hide-details="auto"
              clearable
              append-icon="mdi-chevron-down"
              outlined
              :items="allTypes"
              item-text="name"
              item-value="name"
              @keyup.enter="getReport"
              class="primary-input mr-2"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="2">
            <span class="text ml-1">{{ $t('Ponto de consumo') }}</span>
            <v-autocomplete
              placeholder="Selecione"
              hide-details="auto"
              v-model="reportFilter.comsumptionPointId"
              clearable
              append-icon="mdi-chevron-down"
              outlined
              item-text="name"
              item-value="id"
              :items="allPoints"
              @keyup.enter="getReport"
              class="primary-input mr-2"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="2">
            <span class="text ml-1">{{ $t('Data inicial') }}</span>
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  placeholder="00/00/0000"
                  :value="formatDate(reportFilter.start)"
                  hide-details="auto"
                  clearable
                  outlined
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @keyup.enter="getReport"
                  autocomplete="off"
                  class="primary-input mr-2"
                ></v-text-field>
              </template>
              <v-date-picker locale="pt" v-model="reportFilter.start" no-title>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="2">
            <span class="text ml-1">{{ $t('Data final') }}</span>
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="primary-input"
                  placeholder="00/00/0000"
                  :value="formatDate(reportFilter.end)"
                  :rules="
                    reportFilter.start
                      ? [
                          () =>
                            reportFilter.end >= reportFilter.start ||
                            'Data inválida',
                        ]
                      : []
                  "
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  readonly
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @keyup.enter="getReport"
                ></v-text-field>
              </template>
              <v-date-picker locale="pt" v-model="reportFilter.end" no-title>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="2" class="d-flex justify-center align-center">
            <v-btn class="primary-button mr-0" @click="getReport">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="reportHeaders"
          :items="reportData"
          :items-per-page="reportFilter.pageSize"
          class="main-table"
          hide-default-footer
          hide-default-header
          mobile-breakpoint="0"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.consumptionType.name`]="{ item }">
            <span> {{ item.consumptionType.name }} </span>
          </template>
          <template #[`item.consumptionPoint.name`]="{ item }">
            <span> {{ item.consumptionPoint.name }} </span>
          </template>

          <template #[`item.value`]="{ item }">
            <span> {{ item.value }} {{ item.consumptionType.unityName }} </span>
          </template>
          <template #[`item.unityValue`]="{ item }">
            <span> {{ formatCurrency(item.unityValue) }} </span>
          </template>
          <template #[`item.finalValue`]="{ item }">
            <span> {{ formatCurrency(item.unityValue * item.value) }} </span>
          </template>
          <template #[`item.readingDate`]="{ item }">
            <span> {{ formatDate(item.readingDate) }} </span>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#0F3565"
                  dark
                  small
                  depressed
                  @click="editReading(item)"
                  v-on="on"
                >
                  <v-icon size="22">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Editar') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ma-1"
                  color="#921616"
                  depressed
                  dark
                  small
                  @click="openDeleteReading(item)"
                  v-on="on"
                >
                  <v-icon size="22">mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Excluir') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <div class="pagination mx-2">
          <div class="item-pagination block-one">
            <div class="registros" v-if="reportData.length">
              <span>
                1 - {{ reportData.length }} de {{ reportFilter.totalItems }}
              </span>
              <br />
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="reportFilter.page"
              :length="totalPages"
              :total-visible="5"
            ></v-pagination>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="deleteDialog" max-width="350">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir o item') }}
            {{ currentItem.name }}?
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
    <v-dialog v-model="readingDeleteDialog" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir a leitura?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="readingDeleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="removeReading"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <ManageReadings
        :title="$t('Adicionar Leitura')"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="800px" persistent>
      <ManageReadings
        :title="$t('Editar Leitura')"
        :reading="currentReading"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import FormatDate from '../../../Utils/FormatDate'
import ManageReadings from './components/ManageReadings.vue'
import * as pbi from 'powerbi-client'

export default {
  name: 'ConsumptionPage',

  data() {
    return {
      allTypes: [],
      points: [],
      report: null,
      reportTab: null,
      reportPages: [],
      tokens: {},
      currentReading: {},
      editDialog: false,
      tab: 0,
      apiService: new ApiService(),
      show: false,
      loading: false,
      items: [],
      currentItem: [],
      unidades: [],
      unidLoading: false,
      sizes: [10, 30, 90, 180],
      totalPages: 1,
      totalItems: 0,
      typeFilter: {
        name: '',
        institutionId: null,
        page: 1,
        pageSize: 10,
      },
      reportFilter: {
        name: '',
        unity: null,
        institutionId: null,
        page: 1,
        pageSize: 10,
        start: '',
        end: '',
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Tipo',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unityName',
        },

        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      reportHeaders: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Tipo de consumo',
          align: 'center',
          value: 'consumptionType.name',
        },
        {
          text: 'Ponto de consumo',
          align: 'center',
          value: 'consumptionPoint.name',
        },
        {
          text: 'Valor de consumo',
          align: 'center',
          value: 'total',
        },
        {
          text: 'Preço por Unidade',
          align: 'center',
          value: 'unityValue',
        },
        {
          text: 'Valor',
          align: 'center',
          value: 'finalValue',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'readingDate',
        },

        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      institution: {},
      deleteDialog: false,

      readingDeleteDialog: false,

      reportData: [],
      user: {},
      dialogKey: false,
      dialog: false,
    }
  },

  components: {
    ManageReadings,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.typeFilter.institutionId = this.institution.id
    this.reportFilter.institutionId = this.institution.id

    Promise.all([this.list(), this.getTypes(), this.getReport()])
  },

  async mounted() {
    await this.getToken()
    try {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )

      let models = pbi.models

      var basicFilter = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'unidades',
          column: 'InstitutionId',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      var basicFilter8 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'institutions',
          column: 'Id',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      // var basicFilter2 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'equipacarefix-hmg-mock consumptionreading',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      // var basicFilter3 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'equipacarefix-hmg-mock consumptiontype',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      let embedConfiguration = {
        type: 'report',
        id: '0ec21473-9d15-4e01-a3f2-7c9c1353f4b7',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1CLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3D',
        tokenType: models.TokenType.Embed,
        accessToken: this.tokens.token,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
      }
      let reportContainer = document.getElementById('reportContainer')

      this.report = powerbi.embed(reportContainer, embedConfiguration)

      const self = this

      this.report.on('loaded', (event) => {
        this.report.getFilters().then(async (filters) => {
          filters.push(...[basicFilter, basicFilter8])

          self.reportPages = await self.report.getPages()

          self.reportPages = self.reportPages.filter(
            (x) => x.visibility === 0 && x.displayName != 'Dashboard'
          )

          self.report.setPage(self.reportPages[0].name)

          return self.report.setFilters(filters)
        })
      })
    } catch (err) {}
  },

  computed: {
    allPoints() {
      if (this.reportFilter.name && this.reportFilter.name != 'null') {
        const type = this.allTypes.find((x) => x.name == this.reportFilter.name)
        return this.points.filter((x) => x.consumptionTypeId == type.id)
      }

      return this.points
    },
  },

  methods: {
    getTypes() {
      this.apiService
        .get(`ConsumptionType/list?institutionId=${this.institution.id}`)
        .then((response) => {
          this.allTypes = response.content
          this.points = this.allTypes
            .map(function (p) {
              return p.consumptionPoints
            })
            .reduce(function (a, b) {
              return a.concat(b)
            }, [])
        })
    },

    async getToken() {
      await this.apiService
        .get(
          'consumptionReading/getAccessToken?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&datasetId=509c084a-a659-407b-b002-61d57b5068da'
        )
        .then((response) => {
          this.tokens = response.content
        })
    },

    addReading() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editReading(item) {
      this.currentReading = item
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },
    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.reportReset()
    },

    formatCurrency(value) {
      return value != null ? value.toInstLocale() : 0
    },

    openDelete(item) {
      this.currentItem = item
      this.deleteKey = !this.deleteKey
      this.deleteDialog = true
    },
    openDeleteReading(item) {
      this.currentReading = item
      this.readingDeleteKey = !this.readingDeleteKey
      this.readingDeleteDialog = true
    },
    removeReading() {
      this.loading = true
      this.apiService
        .delete(`consumptionreading/${this.currentReading.id}`)
        .then(() => {
          this.getReport()
          this.$toast.success(this.$t('Leitura excluída com sucesso!'))
          this.loading = false
          this.readingDeleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.readingDeleteDialog = false
        })
    },

    remove() {
      this.loading = true
      this.apiService
        .delete(`consumptiontype/${this.currentItem.id}`)
        .then(() => {
          this.list()
          this.$toast.success(this.$t('Tipo excluído com sucesso!'))
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    reset() {
      this.typeFilter.page = 1

      this.typeFilter.name = ''
      this.list()
    },

    reportReset() {
      this.reportFilter.name = ''

      this.typeFilter.page = 1

      this.typeFilter.name = ''
      this.getReport()
    },

    getReport() {
      const model = {
        name: this.reportFilter.name,
        institutionId: this.reportFilter.institutionId,
        start: this.reportFilter.start,
        end: this.reportFilter.end,
        comsumptionPointId: this.reportFilter.comsumptionPointId,
        page: this.reportFilter.page,
        pageSize: this.reportFilter.pageSize,
      }
      if (this.reportFilter.unity !== null) {
        model.unity = this.reportFilter.unity
      }
      this.apiService
        .post(`consumptionreading/paginate`, model)
        .then((response) => {
          this.reportData = response.content.data
          const pager = response.content.pager
          this.reportFilter.page = pager.currentPage
          this.reportFilter.pageSize = pager.pageSize
          this.reportFilter.totalItems = pager.totalItems
          this.totalPages = pager.totalPages
        })
    },

    list() {
      this.apiService
        .get('consumptiontype/paginate', this.typeFilter)
        .then((response) => {
          const pager = response.content.pager

          this.typeFilter.totalItems = pager.totalItems
          this.items = response.content.data

          this.typeFilter.page = pager.currentPage
          this.typeFilter.pageSize = pager.pageSize

          this.typeFilter.totalPages = pager.totalPages
        })
    },
  },

  watch: {
    'typeFilter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'typeFilter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'reportFilter.page': {
      deep: true,
      handler() {
        this.getReport()
      },
    },
  },
}
</script>

<style scoped>
#reportContainer {
  width: 100% !important;
  height: 90vh;
}
</style>
